/**
 * Edge rules dispatcher.
 * Runs diagram-type-specific rules as a pre-render pass,
 * enriching edge.meta after layout and before rendering.
 */

import type { IRGraph } from '../types';
import { applyEdgeRules as activityRules, applyPreLayoutRules as activityPreLayout } from './activity-rules';
import { applyEdgeRules as classRules } from './class-rules';
import { applyEdgeRules as erRules } from './er-rules';
import { applyEdgeRules as flowchartRules } from './flowchart-rules';
import { applyEdgeRules as stateRules } from './state-rules';

const RULES_BY_TYPE: Record<string, (graph: IRGraph) => void> = {
  flowchart: flowchartRules,
  class: classRules,
  state: stateRules,
  er: erRules,
};

export function applyPreLayoutRules(graph: IRGraph, outputFormat: string): void {
  if (outputFormat === 'drawio-activity') {
    activityPreLayout(graph);
  }
}

export function applyRules(graph: IRGraph, outputFormat: string): void {
  // Activity rules are triggered by output format, not diagram type,
  // because flowchart diagrams can render as either flowchart or activity.
  if (outputFormat === 'drawio-activity') {
    activityRules(graph);
    return;
  }
  const fn = RULES_BY_TYPE[graph.diagramType];
  if (fn) fn(graph);
}
